import React from 'react';
import {connect} from 'react-redux';

import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';

class FAQ extends React.Component {

    render() {
        return <FullWidthPage title="Въпроси">
            <div className="col-md-12 faq">
                <SectionTitle>Често задавани въпроси</SectionTitle>

                <h4>Какво е mindfulness/съзнателност?</h4>
                <p>Съзнателността е древна будистка практика, която е много актуална днес. Тя означава да се
                    “събудиш” и да заживееш в хармония със себе си и света. Означава да се почувстваш отново
                    свързан.</p>

                <p>Съзнателността е проста концепция, а силата й се крие в практиката и в приложението. Тя ни помага да
                    излезем от матрицата и да се свържем със собствената си мъдрост и жизненост. Ключът по пътя е да ценим
                    настоящия момент и да изградим интимна връзка с него, като му отдаваме пълното си внимание и грижа. Това е
                    точно обратното на това да възприемаме живота като даденост.</p>

                <p>В днешно време медитацията не е религиозна практика, а по-скоро предлага един философски поглед към
                    света. При медитацията най-важното е да бъдеш себе си и да не искаш да бъдеш нещо, което вече не си.</p>

                <h4>Всеки ли може да медитира?</h4>

                <p>Разбира се. Това е като дишането или като способността да се отпуснеш или концентрираш. Често
                    медитацията се бърка с релаксация. Да медитираш не означава да се чувстваш по определен начин, а да се чувстваш
                    по начина, по който се чувстваш. В медитацията трябва да позволиш на ума да е такъв, какъвто е и да се
                    опиташ да разбереш как се чувства. Медитацията изисква отдаване и дисциплина. Но е най-честно да си кажеш
                    “не ми се занимава”, отколкото “не мога”. А и предварително да се откажеш от всички очаквания и просто да
                    наблюдаваш.</p>

                <h4>Какво ми носи не-правенето?</h4>

                <p>Важно е да отбележим, че не-правенето не означава да не правим нищо. Най-вече защото при не-правенето
                    имаме съзнателност и намерение. Медитацията е съзнателно отделяне на време да спрем всяка външна
                    дейност с никакво друго намерение освен да присъстваме и бъдем в настоящия момент. Подобни моменти на
                    не-правене са може би най-големия подарък, който можем да си направим. При медитацията “правенето” отстъпва на
                    “бъденето”.</p>

                <h4>Какво означава “да пусна” нещо?</h4>

                <p>Отвъд клишчето на “пускането”, “да пуснеш” е покана да спреш да “стискаш” нещо - било то идея, вещ,
                    събитие, определено време, възглед или желание. Означава да престанеш да се съпротивляваш или бориш
                    в замяна на нещо по-силно и естествено, което произлиза от това да оставиш нещата да бъдат такива, каквито
                    са. Преносно казано, да отвориш дланта си и да пуснеш нещо, за което си се вкопчил.</p>

                <h4>Медитацията позитивно мислене ли е?</h4>

                <p>Позитивното мислене не е медитация, най-вече защото то е още мислене. И също като негативното мислене
                    може да бъде ограничаващо, фрагментирано, неточно, самозаблуждаващо и погрешно.</p>

                <p>Съзнателността не е същото като мисленето. Тя е отвъд него, въпреки че се ползва от мисленето и
                    оценява неговата стойност и сила. Съзнателността е по-скоро като съд, който държи мислите ни и ни помага да
                    ги видим като такива, отколкото да ги смятаме за реалност. В медитацията ние не се опитваме да променим
                    мисленето си чрез още мислене. А просто наблюдаваме мислите си. Наблюдаването е “държането” на мислите.</p>

                <h4>В каква поза е най-подходящо да медитирам?</h4>

                <p>Има много подходящи пози за медитация - седяща, лежаща, изправена, можеш да медитираш дори и в
                    движение. Ние ти препоръчваме да медитираш седнал на стол или в поза лотус на земята, защото тази поза излъчва
                    будност и достойнство и едновременно стабилност като планина.</p>

                <h4>Какви са предимствата на седящата и лежащата медитация?</h4>

                <p>При седящата поза има достойнство, стабилност и будност.
                    Лежащата поза напомня на езеро. Можеш да си представиш, че си като водата, която отразява всичко и
                    която се “съдържа” в езерото. Тя ти помага да си отворен и да отразяваш всичко, което се появи.</p>

                <h4>Какво да правя с ръцете си?</h4>

                <p>Позата на ръцете е в тясна връзка с езика на тялото, който е индивидуален. Всяка поза на тялото
                    излъчва определена енергия, включително и какво правим с ръцете си. Експериментирай. Постави ръцете си в
                    дланите надолу и забележи как се затваряш в себе си. След това ги обърни нагоре и усети как ставаш отворен и
                    открит за енергията.</p>

                <h4>Как да излизам от медитация?</h4>

                <p>Излизането от медитация е деликатен момент. Много е лесно да се разсееш към края на практиката и дори
                    да не го усетиш. Но излизането от медитация може да бъде отличен начин да упражняваме съзнателност.
                    Както с целия процес на дишане, наблюдавай как излизаш от практика и какво се случва.</p>

                <h4>Колко дълго да медитирам?</h4>

                <p>Истината е, че няма правилен и грешен отговор на този въпрос. В оптималния случай те съветваме да
                    отделяш по 20 мин. на ден в продължение на поне 8 седмици.</p>

                <p>Въпреки това, ние осъзнаваме, че в днешно време малко хора могат да си го позволят. Именно затова
                    нашите водени медитации са с продължителност 10 минути. Най-важното, че медитацията не зависи от времето, а
                    от искреността и качеството на вложеното усилие. В медитацията става въпрос за излизане от минутите и
                    часовете и за навлизане в моменти, които са безкрайни. Мотивацията да практикуваш е най-важна. Съзнателността
                    трябва да бъде грижливо отглеждана и пазена от ветровете на динамичния живот и на неспокойния и тревожен
                    ум, като пламъче в буря.</p>

                <h4>Има ли правилен начин?</h4>

                <p>Не. Но когато посрещаме всеки момент с открит ум и сърце и ценим богатия потенциал, който носи, сме
                    на прав път. В медитацията е най-добре да се оставим и ценим собственото си преживяване, а не да се
                    питаме: “това ли трябва да усещам?”</p>

                <h4>Какво е медитация като планина?</h4>

                <p>Планината е архетипен символ във всички култури. Хората винаги са търсили в нея духовно напътствие и
                    възраждане. Планините са считани за свещени и олицетворяват страховитост и хармония, суровост и
                    царственост. В медитацията като планина седим на пода със скръстени крака, със солидна основа като планина,
                    едновременно достолепно изправени и отпуснати. В тази поза може да се почувстваме като планина, отвътре и отвън.
                    Можем да си представим най-красивата планина, която сме виждали и мислено да се слеем с нея. Планината е
                    прекрасен образ на едно спокойно и силно присъствие.</p>

                <h4>Какво представлява медитацията като езеро?</h4>

                <p>Образът не езерото е особено полезен при медитация. То се свързва с лежащата поза и с водата, която
                    заема най-ниското място. Водата е най-силната стихия, защото променя дори камъка. Освен това ако я удариш,
                    тя се отдръпва, след което отново заема същото място. По същия начин като езерото, позволи на ума и
                    сърцето си да са отворени за това, което присъства.</p>


                <h4>Кой период от деня е най-подходящ за медитация?</h4>

                <p>Бихме ти препоръчали ранна утрин, при изгрев слънце (по възможност преди кафето). Раждането на деня е
                    специален момент във всяко едно отношение. Ставането толкова рано всяка сутрин е съзнателно усилие и
                    изисква вътрешна отдаденост, дори когато не ти се прави по хиляди други причини. Подобна сериозна практика
                    води до осъзнаването, че в живота има по-важни неща от това да правиш нещата и да вършиш работа. А и
                    независимо от това, което ни се случва - добро и лошо, придобиваме перспектива на стабилност, мъдрост и вътрешен
                    мир, независимо от обстоятелствата.</p>

                <p>Но най-важното при медитациите е не кога, а редовната практика. Всичко зависи от твоя начин на живот
                    и кога имаш възможност да се усамотиш и да си подариш пространство за себе си. Важно е искреното усилие и
                    качеството на практиката, а не кога и колко време.</p>
            </div>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(FAQ);




// WEBPACK FOOTER //
// ./src/components/Pages/Faq.js